
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { pressureData } from '@/data/water-analytics-data';

const WaterPressureChart = () => {
  return (
    <AnimatedCard 
      animation="fade-up"
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Water Pressure Monitoring (bar)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={pressureData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" />
              <YAxis domain={[3.7, 4.3]} />
              <Tooltip 
                formatter={(value) => [`${value} bar`, 'Pressure']}
                contentStyle={{ 
                  borderRadius: '8px', 
                  border: 'none', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                }}
              />
              <Line 
                type="monotone" 
                dataKey="pressure" 
                stroke="#0EA5E9" 
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default WaterPressureChart;
